import { render } from "./PlayerMenu.vue?vue&type=template&id=12ce4c0f&scoped=true"
const script = {}

import "./PlayerMenu.vue?vue&type=style&index=0&id=12ce4c0f&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ce4c0f"]])

export default __exports__